export enum PartnerRole {
  MANAGER = 'MANAGER',
  EMPLOYEE = 'EMPLOYEE',
  RETURN_STATION = 'RETURN_STATION',
}
